module.exports = __webpack_public_path__ + "static/media/success.150e7322.svg";